import React from 'react';
import { useCesium } from '../../../context/CesiumContext';
import styles from './MapTools.module.scss';

const GlobeIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <circle cx="7" cy="7" r="5.5" stroke="currentColor" strokeWidth="1.2" />
    <ellipse cx="7" cy="7" rx="2.5" ry="5.5" stroke="currentColor" strokeWidth="1.2" />
    <path d="M1.5 7h11" stroke="currentColor" strokeWidth="1.2" />
    <path d="M2.5 4h9M2.5 10h9" stroke="currentColor" strokeWidth="1" strokeDasharray="1.5 1" />
  </svg>
);

const ZoomStack: React.FC = () => {
  const cesium = useCesium();
  const level = cesium.getZoomLevel();

  return (
    <div className={styles.zoomStack}>
      <button className={styles.zoomBtn} type="button" title="Zoom in" onClick={cesium.zoomIn}>
        <span>+</span>
      </button>
      <div className={styles.zoomLevel}>{level}</div>
      <button className={styles.zoomBtn} type="button" title="Zoom out" onClick={cesium.zoomOut}>
        <span>−</span>
      </button>
      <button className={`${styles.zoomBtn} ${styles.globeBtn}`} type="button" title="Reset view" onClick={cesium.resetZoom}>
        <GlobeIcon />
      </button>
    </div>
  );
};

export default ZoomStack;
